import controller from './venue-hours.controller';
import template from './venue-hours.html';

const component = {
    template,
    controller: [controller],
};

export default component;
